// Wrapper around our Typography SubHeader
import withTypography from './withTypography'
import SubHeader from '../components/ui/Typography/SubHeader'

export default withTypography(SubHeader)
